export default __webpack_public_path__ + "static/media/standard_09.d4029bdc.png";